import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import focusDropdownSearch from 'scaleflow/utils/focus-dropdown-search';
import nameSort from 'scaleflow/utils/nameSort';

export default class DropdownsIdeasComponent extends Component {
  @service store;
  @service betaToggle;

  @tracked textFilter = null;

  allowedStatus = [
    'NEW',
    'UNDER_REVIEW',
    'APPROVED',
    'REJECTED',
    'IMPLEMENTED',
  ];

  tippyInstance = null;

  get ComponentName() {
    return this.args?.tippy ? 'Tippy' : 'empty-component';
  }

  get trigger() {
    return this.args?.trigger ?? '';
  }

  get placement() {
    return this.args.placement ?? 'top';
  }

  get interactive() {
    return this.args.interactive ?? false;
  }

  get ideas() {
    const ideas = this.store.peekAll('idea');
    return !this.textFilter
      ? ideas
      : ideas.filter(
          (item) =>
            item.title.toLowerCase().indexOf(this.textFilter.toLowerCase()) >=
            0,
        );
  }

  get ideasList() {
    const ideas = this.ideas;
    let filtered = [];
    if (this.args.allowAllStatuses) filtered = [...ideas];
    else
      filtered = ideas.filter((item) =>
        this.allowedStatus.includes(item?.status?.toUpperCase?.()),
      );
    return filtered.sort((a, b) => nameSort(a.title, b.title));
  }

  @action
  handleIdeaClick(item) {
    this.args?.onSelect?.(item);
    this.tippyInstance.hide();
  }

  @action
  handleSearch(text) {
    this.textFilter = text;
  }

  @action
  onShown(instance) {
    focusDropdownSearch(instance);
  }

  @action
  onCreate(e) {
    this.tippyInstance = e;
  }

  @action
  handleClearSelection() {
    this.args?.handleClearSelection();
    this.tippyInstance.hide();
  }
}
